import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { useAuthStore } from '@/stores/auth'

export const Route = createFileRoute('/_authenticated/inquiries')({
  beforeLoad: () => {
    const user = useAuthStore.getState().user
    if (user && !user.acl?.inquiry && !user.acl?.administrator) {
      throw redirect({ to: '/' })
    }
  },
  component: InquiriesLayout,
})

/**
 * 引合管理画面のレイアウトルート
 */
function InquiriesLayout() {
  useDocumentTitle('引合管理')
  return (
    <div className='h-full'>
      <Outlet />
    </div>
  )
}
